export default __webpack_public_path__ + "static/media/belop_Page_2.704e8e6b.png";